import { Spin, Flex } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import clsx from "clsx";
import css from "./index.module.scss";

const Loading = ({ loading, ...props }) => (
	<Flex className={clsx(css["loadingWrap"])}>
		<Spin
			indicator={<LoadingOutlined style={{ fontSize: 24 }} />}
			// tip={"Loading" }
			// size="large"
			className={clsx(css["request-loading"])}
			spinning={loading || false}
			{...props}
		/>
	</Flex>
);

export default Loading;
